import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { getProfileInfo } from 'modules/_common/api';

export const useQueryProfileInfo = (isAuthenticated?: boolean) => {
  const { errorToast } = useCustomToast();

  const {
    data,
    isLoading: isLoadingProfileInfo,
    error: errProfileInfo,
    isFetching: isFetchingProfileInfo,
    refetch: refetchProfileInfo,
  } = useQuery(QUERY_KEYS.SETTINGS_PROFILE, getProfileInfo, {
    enabled: isAuthenticated,
    onError: () => errorToast(),
  });

  return {
    profileInfo: data?.data,
    isLoadingProfileInfo,
    errProfileInfo,
    isFetchingProfileInfo,
    refetchProfileInfo,
  };
};
